"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonDetailsLayout = exports.PersonDetailsLayoutDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_lang_1 = require("../../hooks/use-lang");
var use_entities_1 = require("../../hooks/use-entities");
var lodash_1 = require("lodash");
var link_1 = require("../elements/link");
var content_node_1 = require("./content-node");
var main_aside_1 = require("../elements/main-aside");
var entity_link_value_1 = require("./entity-link-value");
var entity_link_1 = require("./entity-link");
var entity_value_1 = require("./entity-value");
var content_title_1 = require("../elements/content-title");
var entity_multi_value_list_1 = require("./entity-multi-value-list");
var content_section_1 = require("../elements/content-section");
var entity_contact_info_1 = require("./entity-contact-info");
var entity_list_1 = require("./entity-list");
var quote_row_1 = require("./quote-row");
var entity_list_section_1 = require("./entity-list-section");
var grid_1 = require("../elements/grid");
var coalesce_1 = require("../../utils/coalesce");
exports.PersonDetailsLayoutDefaultProps = {};
// -------- Styles -------->
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LocationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var RolesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentNodeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n\n    &:first-child {\n      padding-top: ", ";\n    }\n  "], ["\n    padding: ", " 0 ", ";\n\n    &:first-child {\n      padding-top: ", ";\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1))
});
var BioContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ContentNodeStyles)
});
var PlatformObjectiveStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ContentNodeStyles)
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    font-size: ", ";\n    font-weight: 500;\n  "], ["\n    margin-bottom: ", ";\n    font-size: ", ";\n    font-weight: 500;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.FONT_SIZE(15))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: inline-block;\n  "], ["\n    display: inline-block;\n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ExpertiseValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-right: ", ";\n    display: inline-block;\n  "], ["\n    margin-bottom: ", ";\n    margin-right: ", ";\n    display: inline-block;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2))
});
var EntityLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    display: inline-block;\n  "], ["\n    margin-bottom: ", ";\n    display: inline-block;\n  "])), theme_1.theme.UNIT(4))
});
var MultiListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var ContactStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var ExpertiseLevelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Container: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Contact: (0, styled_components_1.default)(entity_contact_info_1.EntityContactInfo)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ContactStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Location: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), LocationStyles),
  Roles: styled_components_1.default.div(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), RolesStyles),
  EntityLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), EntityLinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  ExpertiseValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ExpertiseValueStyles),
  ExpertiseLevel: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ExpertiseLevelStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  Bio: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), BioContentStyles),
  PlatformObjective: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), PlatformObjectiveStyles),
  MultiList: (0, styled_components_1.default)(entity_multi_value_list_1.EntityMultiValueList)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), MultiListStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), ListStyles)
};
var PersonDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    mainHeader = props.mainHeader,
    expertise = props.expertise,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    banner = props.banner;
  var t = (0, use_lang_1.useLang)();
  var entities = (0, use_entities_1.useEntities)();
  var _a = entity || {},
    _b = _a.chapterRoles,
    chapterRoles = _b === void 0 ? [] : _b,
    _c = _a.teamRoles,
    teamRoles = _c === void 0 ? [] : _c,
    _d = _a.locations,
    locations = _d === void 0 ? [] : _d,
    _e = _a.economies,
    economies = _e === void 0 ? [] : _e,
    platformObjective = _a.platformObjective,
    bio = _a.bio,
    _f = _a.quotes,
    quotes = _f === void 0 ? [] : _f,
    _g = _a.pages,
    pages = _g === void 0 ? [] : _g,
    _h = _a.challengeExpertise,
    challengeExpertise = _h === void 0 ? [] : _h,
    _j = _a.keyIssueExpertise,
    keyIssueExpertise = _j === void 0 ? [] : _j,
    _k = _a.sdgExpertise,
    sdgExpertise = _k === void 0 ? [] : _k,
    _l = _a.topicExpertise,
    topicExpertise = _l === void 0 ? [] : _l,
    _m = _a.subTopicExpertise,
    subTopicExpertise = _m === void 0 ? [] : _m,
    _o = _a.trendExpertise,
    trendExpertise = _o === void 0 ? [] : _o,
    _p = _a.videos,
    videos = _p === void 0 ? [] : _p,
    _q = _a.colleagues,
    colleagues = _q === void 0 ? [] : _q,
    _r = _a.posts,
    posts = _r === void 0 ? [] : _r,
    _s = _a.moderating,
    moderating = _s === void 0 ? [] : _s,
    _t = _a.courseRegistrations,
    courseRegistrations = _t === void 0 ? [] : _t,
    _u = _a.teams,
    teams = _u === void 0 ? [] : _u;
  var positions = (0, lodash_1.reverse)((0, lodash_1.sortBy)(entity.positions, function (position) {
    return position.primary;
  }));
  var hasTeamRoles = teamRoles && !!teamRoles.length;
  var hasChapterRoles = !!chapterRoles.length;
  var hasPositions = !!positions.length;
  var bioText = (0, lodash_1.trim)((0, coalesce_1.coalesce)(entity, ['bio.text']));
  var objectiveText = (0, lodash_1.trim)((0, coalesce_1.coalesce)(entity, ['platformObjective.text']));
  var hasEconomies = !!(economies === null || economies === void 0 ? void 0 : economies.length);
  var hasLocations = !!(locations === null || locations === void 0 ? void 0 : locations.length);
  var hasQuotes = !!(quotes === null || quotes === void 0 ? void 0 : quotes.length);
  var hasVideos = !!(videos === null || videos === void 0 ? void 0 : videos.length);
  var hasPosts = !!(videos === null || videos === void 0 ? void 0 : videos.length);
  var hasColleagues = !!(colleagues === null || colleagues === void 0 ? void 0 : colleagues.length);
  var hasCourseRegistrations = !!(courseRegistrations === null || courseRegistrations === void 0 ? void 0 : courseRegistrations.length);
  var hasModerating = !!(moderating === null || moderating === void 0 ? void 0 : moderating.length);
  var hasAbout = !!(bioText || objectiveText);
  var hasPlaces = hasEconomies || hasLocations;
  var hasContact = entity.linkedin || entity.twitter || entity.websiteUrl || entity.facebook || entity.email || entity.phone || entity.url || entity.blogUrl || entity.angelList || entity.pinterest || entity.instagram || entity.youtube;
  var hasExpertise = !!challengeExpertise.length || !!keyIssueExpertise.length || !!sdgExpertise.length || !!topicExpertise.length || !!subTopicExpertise.length || !!trendExpertise.length || expertise;
  var hasPages = !!pages.length;
  var collaborations = teams.filter(function (team) {
    var _a;
    return ((_a = team === null || team === void 0 ? void 0 : team.type) === null || _a === void 0 ? void 0 : _a.slug) === 'collaboration';
  }) || [];
  var hasAside = asideHeader || asideFooter || hasPlaces || hasContact || hasPages;
  return React.createElement(My.Container, {
    className: className
  }, banner, React.createElement(My.MainAside, {
    main: React.createElement(My.Main, null, mainHeader, hasAbout && React.createElement(My.Section, null, React.createElement(My.Bio, {
      entity: bio,
      title: 'About:'
    }), React.createElement(My.PlatformObjective, {
      entity: platformObjective,
      title: 'Platform Objective:'
    })), hasPositions && React.createElement(My.Section, {
      title: "{{ORGANISATION_POSITIONS}}:"
    }, React.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: positions.map(function (position) {
        return React.createElement(My.EntityLink, {
          key: position.id,
          entity: position.organisation
        }, React.createElement(My.Value, {
          badge: (0, lodash_1.get)(position, 'organisation.type.name'),
          entity: position.organisation,
          label: position.position,
          name: position.organisation.name
        }));
      })
    })), hasCourseRegistrations && React.createElement(My.Section, {
      title: "My Courses:"
    }, React.createElement(My.Grid, {
      spacing: 3,
      columns: 2,
      items: courseRegistrations.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: (0, lodash_1.omit)(entity.course, 'badge')
        });
      })
    })), !!collaborations.length && React.createElement(My.Section, {
      title: "My Collaborations:"
    }, React.createElement(My.Grid, {
      spacing: 3,
      columns: 2,
      items: collaborations.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: entity
        });
      })
    })), hasExpertise && React.createElement(My.Section, {
      title: "Expertise & Interest:"
    }, React.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: (0, lodash_1.filter)((0, lodash_1.flatten)([entities.Challenge && (0, lodash_1.flatten)(challengeExpertise.map(function (expertise) {
        return (expertise.challenges || []).map(function (challenge) {
          return React.createElement(My.ExpertiseValue, {
            badge: expertise.badge,
            entity: challenge,
            label: "".concat(entities.Challenge.label, " \u2022 ").concat((0, lodash_1.get)(expertise, 'levelOfExpertise.name'))
          });
        });
      })), entities.KeyIssue && (0, lodash_1.flatten)(keyIssueExpertise.map(function (expertise) {
        return (expertise.keyIssues || []).map(function (keyIssue) {
          return React.createElement(My.ExpertiseValue, {
            badge: expertise.badge,
            entity: keyIssue,
            label: "".concat(entities.KeyIssue.label, " \u2022 ").concat((0, lodash_1.get)(expertise, 'levelOfExpertise.name'))
          });
        });
      })), entities.Trend && (0, lodash_1.flatten)(trendExpertise.map(function (expertise) {
        return (expertise.trends || []).map(function (trend) {
          return React.createElement(My.ExpertiseValue, {
            badge: expertise.badge,
            entity: trend,
            label: "".concat(entities.Trend.label, " \u2022 ").concat((0, lodash_1.get)(expertise, 'levelOfExpertise.name'))
          });
        });
      })), entities.Topic && (0, lodash_1.flatten)(topicExpertise.map(function (expertise) {
        return (expertise.topics || []).map(function (topic) {
          return React.createElement(My.ExpertiseValue, {
            badge: expertise.badge,
            entity: topic,
            label: "".concat(entities.Topic.label, " \u2022 ").concat((0, lodash_1.get)(expertise, 'levelOfExpertise.name'))
          });
        });
      })), entities.SubTopic && (0, lodash_1.flatten)(subTopicExpertise.map(function (expertise) {
        return (expertise.subTopics || []).map(function (subTopic) {
          return React.createElement(My.ExpertiseValue, {
            badge: expertise.badge,
            entity: subTopic,
            label: "".concat(entities.SubTopic.label, " \u2022 ").concat((0, lodash_1.get)(expertise, 'levelOfExpertise.name'))
          });
        });
      })), entities.Sdg && (0, lodash_1.flatten)(sdgExpertise.map(function (expertise) {
        return (expertise.sdgs || []).map(function (sdg) {
          return React.createElement(My.ExpertiseValue, {
            badge: expertise.badge,
            entity: sdg,
            label: "".concat(entities.Sdg.label, " \u2022 ").concat((0, lodash_1.get)(expertise, 'levelOfExpertise.name'))
          });
        });
      }))]))
    }), expertise), hasVideos && React.createElement(My.Section, {
      title: "Videos:"
    }, React.createElement(My.List, {
      showDescription: true,
      items: videos
    })), hasPosts && React.createElement(My.Section, {
      title: "Posts:"
    }, React.createElement(My.List, {
      showDescription: true,
      items: posts
    })), hasQuotes && React.createElement(My.Section, {
      title: "Narratives:"
    }, React.createElement(My.List, {
      rowComponent: quote_row_1.QuoteRow,
      showDescription: true,
      items: quotes
    })), hasTeamRoles && entities.TeamRole && React.createElement(My.Section, {
      title: "{{TEAM_ROLES}}:"
    }, React.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: entity.teamRoles.map(function (teamRole) {
        return React.createElement(My.EntityLink, {
          key: teamRole.id,
          entity: teamRole.team
        }, React.createElement(My.Value, {
          badge: (0, lodash_1.get)(teamRole, 'team.type.name'),
          entity: teamRole,
          label: teamRole.role.name,
          name: teamRole.team.name
        }));
      })
    })), hasChapterRoles && entities.ChapterRole && React.createElement(My.Section, {
      title: "{{CHAPTER_ROLES}}:"
    }, React.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: chapterRoles.map(function (chapterRole) {
        return React.createElement(My.EntityLink, {
          key: chapterRole.id,
          entity: chapterRole.chapter
        }, React.createElement(My.Value, {
          entity: chapterRole,
          label: chapterRole.role.name,
          name: chapterRole.chapter.name
        }));
      })
    })), hasColleagues && React.createElement(My.Section, {
      title: "Works With:"
    }, React.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: colleagues.map(function (person) {
        return React.createElement(My.EntityLink, {
          key: "colleague-".concat(person.id),
          entity: person
        }, React.createElement(My.Value, {
          entity: person,
          label: person.position
        }));
      })
    })), hasModerating && React.createElement(My.Section, {
      title: "Moderating:"
    }, React.createElement(My.Grid, {
      spacing: 3,
      items: moderating.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: entity
        });
      })
    })), mainFooter),
    aside: hasAside && React.createElement(My.Aside, null, asideHeader, hasPlaces && React.createElement(My.Section, {
      title: "Places:"
    }, hasLocations && React.createElement(My.List, {
      items: locations
    }), hasEconomies && React.createElement(My.List, {
      items: economies
    })), hasContact && React.createElement(My.Section, {
      title: "Contact:"
    }, React.createElement(My.Contact, {
      entity: entity
    })), React.createElement(My.ListSection, {
      maxItems: 3,
      items: pages
    }), asideFooter)
  }));
};
exports.PersonDetailsLayout = PersonDetailsLayout;
exports.PersonDetailsLayout.defaultProps = exports.PersonDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43;